module.exports = __webpack_public_path__ + "static/media/heart40.6c7565bd.svg";